import i18n from '@/utils/i18n';
import React from 'react';
import { APP_CONTAINER_ROUTES } from '@/navigators/routes';
import { AppContainerStackParams } from '@/navigators/types';
import { EmployeeNotificationsComponent } from './restaurant/employee-notifications-component';
import { PageContainer } from '@/components/page-container';
import { RouteProp } from '@react-navigation/native';
import { SCREEN_PADDING } from '@/styles';
import { StyleSheet, View } from 'react-native';

interface Props {
  route: RouteProp<
    AppContainerStackParams,
    APP_CONTAINER_ROUTES.AccountNotificationSettings
  >;
}

export const AccountNotificationsScreen: React.FC<Props> = ({ route }) => {
  const {
    params: { userUUID },
  } = route;
  return (
    <PageContainer
      navigationHeaderProps={{
        centerTitle: true,
        showBackButton: true,
        title: i18n.t('notifications'),
      }}
    >
      <View style={styles.base}>
        <EmployeeNotificationsComponent employeeUUID={userUUID} />
      </View>
    </PageContainer>
  );
};

const styles = StyleSheet.create({
  base: {
    paddingHorizontal: SCREEN_PADDING,
  },
});
